import Fragment from "./fragment";

export default class GameControl extends Fragment {
    summarize() {
        return null;
    }
}
